module.exports = __webpack_public_path__ + "img/6-r.2f840464.png";